module.exports = __webpack_public_path__ + "static/media/icon_buscar_produto_carrinho.64b10c59.svg";